import { ArquivoLogAcao, TipoArquivo } from '../generated/backend-enums.js';
export { ArquivoLogAcao, TipoArquivo };
export const TipoArquivoMap = {
    [TipoArquivo.COMPRAS]: 'Arquivo de Compras',
    [TipoArquivo.INTERNO]: 'Arquivo Interno',
    [TipoArquivo.COMERCIAL]: 'Arquivo Comercial',
    [TipoArquivo.APROVACAO]: 'Arquivo de Aprovação',
    [TipoArquivo.AP]: 'Arquivo da AP',
    [TipoArquivo.JOB_BRIEFING]: 'Arquivo de Briefing',
    [TipoArquivo.JOB_PAPER]: 'Arquivo de Paper',
    [TipoArquivo.JOB_ESTUDO_VERBA]: 'Arquivo de Estudo de Verba',
    [TipoArquivo.JOB_PROJETO_EXECUTIVO]: 'Arquivo de Projeto Executivo',
    [TipoArquivo.JOB_PROJETO_FINAL]: 'Arquivo de Projeto Final',
    [TipoArquivo.PO]: 'Arquivo da PO',
    [TipoArquivo.NF]: 'Arquivo da Nota Fiscal',
    [TipoArquivo.JOB_PLANEJAMENTO_APRESENTACAO]: 'Arquivo de Apresentação do Planejamento',
    [TipoArquivo.COMPROVANTE_ENTREGA_FATURAMENTO]: 'Arquivo de Comprovante de Entrega de Faturamento',
    [TipoArquivo.TAREFA]: 'Arquivo da Tarefa',
    [TipoArquivo.EVIDENCIA_BRINDE]: 'Foto do Gift',
};
export const ArquivoLogAcaoMap = {
    [ArquivoLogAcao.UPLOAD]: 'Upload',
    [ArquivoLogAcao.DOWNLOAD]: 'Download',
    [ArquivoLogAcao.DELETE]: 'Exclusão',
    [ArquivoLogAcao.REPLACE]: 'Substituição',
    [ArquivoLogAcao.GET_URL]: 'Acesso ao link',
};
